import { PreferenceType, type PreferenceValue } from '@/contexts/preferences/Preferences.interfaces'
import type { ApiPreferenceCustomerSchema } from '@/interfaces/Api.generated.interfaces'

export const parsePreference = (value: string | ApiPreferenceCustomerSchema, type: PreferenceType): PreferenceValue => {
  if (type === PreferenceType.BOOLEAN) {
    return value.toString().toLowerCase() === 'true'
  }

  if (type === PreferenceType.NUMBER) {
    return Number(value)
  }

  if (type === PreferenceType.STRING) {
    return String(value)
  }

  throw new Error(`Unsupported preference type: ${type}`)
}
